import axios from 'axios'
import { clone, blobPDF } from '@/util/libUtil.js'


const state = () => ({
	agentCustInfo : [],
    isLoading: false,
    contractLoading: false,
    contractPDF: null,
	paths: {
        agentPath: '/api/scraping/agent/get-by-document/',
        contractPath: '/api/scraping/agent/get-contract/',
        invoicePath: '/api/scraping/agent/get-user-invoice/'
	}
})

const mutations = {
    agentCustInfo(state, val) {
        state.agentCustInfo = clone(val)
    },
    isLoading(state, val) {
        state.isLoading = val
    },
    contractLoading(state, val) {
        state.contractLoading = val
    },
    contractPDF(state, val) {
        state.contractPDF = val
    }
}

const actions = {
    async agentCustomerInfo({ dispatch, getters, state, commit }, document) {
        try {
            commit('isLoading', true)
            const response = await axios.get(getters.getEndpointFromPath(state.paths.agentPath) + document)
            const {data} = response
            if (data?.request_error || response.status !== 200) {
                return {
                    request_error: data.request_error || response.statusText,
                    error: data.error || response.statusText
                }
            }
            commit('agentCustInfo', data)
        } catch (error) {
            console.log(error)
        } finally {
            commit('isLoading', false)
        }
    },
    async agentContract({ dispatch, getters, state, commit }, contract_id) {
        try {
            commit('contractLoading', true)
            const response = await axios.get(getters.getEndpointFromPath(state.paths.contractPath) + contract_id, {responseType: 'blob'})
            blobPDF(response, '')
        } catch (error) {
            console.log(error)
        } finally {
            commit('contractLoading', false)
        }
    },
    async agentInvoice({ dispatch, getters, state, commit }, invoice_id) {
        try {
            commit('contractLoading', true)
            const params = {
                invoice_id: invoice_id
            }
            const response = await axios.get(getters.getEndpointFromPath(state.paths.invoicePath), {params, responseType: 'blob'})
            blobPDF(response, '')
        } catch (error) {
            console.log(error)
        } finally {
            commit('contractLoading', false)
        }
    }
}

const getters = {
	getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
		rootState.general.host + endpoint
	)
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}